import { Box, Container, Typography } from "@mui/material";
import MontlyData from "../../components/trader/MontlyData";
import ShowToken from "../../components/trader/ShowToken";
import TraderInfo from "../../components/trader/TraderInfo";
import { useAuth } from "../../providers/AuthenticationProvider";
import AffiliateMonthlyChart from "../../components/affiliate/AffiliateMonthlyChart";
import { useAffiliateProvider } from "../../providers/AffiliateProvider";
import AffiliateInfo from "../../components/affiliate/AffiliateInfo";
import { useEffect } from "react";
import logo from "../../assets/logo.png";
import AffiliateTotalPayments from "../../components/affiliate/AffiliateTotalPayments";
import CreditToBePaid from "../../components/affiliate/CreditToBePaid";
import TotalEurosMade from "../../components/affiliate/TotalEurosMade";
import { useTranslation } from "react-i18next";

export const Affiliate = () => {
	const {
		affiliate,
		getMonthlyHistory,
		monthlyHistory,
		monthlyHistoryAffiliateMaster,
	} = useAffiliateProvider();

	const { t } = useTranslation();
	const { profile } = useAuth();
	useEffect(() => {
		if (affiliate == null || profile == null) return;
		getMonthlyHistory(affiliate.uid);
	}, [affiliate]);
	return (
		<>
			<Container
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: "16px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						mt: "16px",
						justifyContent: "space-between",
					}}
				>
					<img
						src={logo}
						loading="lazy"
						width="125px"
						height="40px"
					/>
				</Box>
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					flexDirection="row"
					flexWrap="wrap"
					sx={{ padding: { xs: "8px", md: "32px" } }}
				>
					{affiliate != null && (
						<AffiliateInfo affiliate={affiliate} />
					)}
				</Box>
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					flexDirection="row"
					flexWrap="wrap"
					rowGap="16px"
				>
					<CreditToBePaid />
					<TotalEurosMade />
					<AffiliateTotalPayments />
				</Box>
				{profile?.role === "AffiliateMaster" && (
					<>
						<Typography>
							{t("affiliate.affiliate_master.own_code")}
						</Typography>
					</>
				)}

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					{monthlyHistory != null && (
						<Box sx={{ width: "100%" }}>
							<AffiliateMonthlyChart
								monthlyHistory={monthlyHistory}
							/>
						</Box>
					)}
				</Box>
				{profile?.role === "AffiliateMaster" && (
					<>
						<Typography>
							{t(
								"affiliate.affiliate_master.affiliated_linked_earned"
							)}
						</Typography>
						{affiliate != null &&
							affiliate.affiliateLinked?.map((value, index) => {
								return value;
							})}

						<Typography>
							{t(
								"affiliate.affiliate_master.affiliated_linked_earned"
							)}
						</Typography>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{monthlyHistoryAffiliateMaster != null && (
								<Box sx={{ width: "50%" }}>
									<AffiliateMonthlyChart
										monthlyHistory={
											monthlyHistoryAffiliateMaster
										}
									/>
								</Box>
							)}
						</Box>
					</>
				)}
			</Container>
		</>
	);
};
